import { useEffect } from "react";
import { Grid } from "@pankod/refine-mui";
import { useSelect } from "@pankod/refine-core";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  setFieldsSettings,
}) {
  const { options: roomsAC } = useSelect({
    resource: "rooms",
    optionLabel: "title",
    optionValue: "id",
  });

  const fields = [
    {
      type: "text",
      name: "title",
      label: "Title",
      localized: true,
    },
    {
      label: "Description",
      name: "description",
      required: true,
      type: "text",
      lines: 6,
      localized: true,
    },
    {
      label: "Destination",
      name: "destination",
      required: true,
      type: "text",
    },
    {
      label: "Rooms",
      name: "rooms",
      required: true,
      type: "multi-select",
      options: roomsAC,
    },
  ];

  useEffect(() => {
    setFieldsSettings(fields);
  }, []);

  return (
    <Grid container spacing={2} justifyContent="center">
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
